const goSampleCode = `package main
import (
 "net/http"
  "io"
)

func main() {

  http.HandleFunc("/", func (w http.ResponseWriter, r *http.Request) {

  //Write function here 
 io.WriteString(w,"<h1> Hello World !!</h1>")

})
  http.ListenAndServe(":443", nil)}`;

const pythonSampleCode = `def application(environ, start_response):
    start_response('200 OK', [('Content-Type', 'text/plain')])
    yield b'Hello,WSGI'`;

export const defaultCodes = (code) => {
  if (code === "Go") {
    return goSampleCode;
  }
  if (code === "Python") {
    return pythonSampleCode;
  }
};
